'use strict';

require('lazysizes/plugins/object-fit/ls.object-fit');

require('lazysizes/plugins/parent-fit/ls.parent-fit');

require('lazysizes/plugins/rias/ls.rias');

require('lazysizes/plugins/bgset/ls.bgset');

require('lazysizes');

require('lazysizes/plugins/respimg/ls.respimg');

require('../vendor/tweenmax');

require('../../styles/theme.scss');

require('../../styles/theme.scss.liquid');

var _themeA11y = require('@shopify/theme-a11y');

var _carousel = require('../common/carousel');

var _carousel2 = _interopRequireDefault(_carousel);

var _stickyElements = require('../common/sticky-elements');

var _stickyElements2 = _interopRequireDefault(_stickyElements);

var _offcanvas = require('../common/offcanvas');

var _offcanvas2 = _interopRequireDefault(_offcanvas);

var _popups = require('../common/popups');

var _popups2 = _interopRequireDefault(_popups);

var _scrollHeaderClass = require('../common/scroll-header-class');

var _scrollHeaderClass2 = _interopRequireDefault(_scrollHeaderClass);

var _globalScripts = require('../common/global-scripts');

var _globalScripts2 = _interopRequireDefault(_globalScripts);

var _ajaxCart = require('../common/ajax-cart');

var _ajaxCart2 = _interopRequireDefault(_ajaxCart);

require('../common/fly');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import {cookiesEnabled} from '@shopify/theme-cart';

// Common a11y fixes
(0, _themeA11y.focusHash)();
(0, _themeA11y.bindInPageLinks)();

// Apply a specific class to the html element for browser support of cookies.
// if (cookiesEnabled()) {
//   document.documentElement.className = document.documentElement.className.replace(
//     'supports-no-cookies',
//     'supports-cookies',
//   );
// }

(0, _carousel2.default)();
(0, _stickyElements2.default)();
(0, _offcanvas2.default)();
(0, _popups2.default)();
(0, _scrollHeaderClass2.default)();
(0, _globalScripts2.default)();
(0, _ajaxCart2.default)();